/** @module csi/widget/_svg/ShapeAlignLeft */
define([
	"./_ShapeAlign",
	"./PluginFactory"
], function(_ShapeAlign,PluginFactory) {

	return PluginFactory.declare(_ShapeAlign, {
		/**
		 * @property {String} iconClass - CSS class to be applied.
		 */
		iconClass: "csiActionIcon svgIconAlignLeft",

		/**
		 * @property {String} pluginName - Plugin name to be used for adding to toolbar.
		 */
		pluginName: "shapeAlignLeft",

		/**
		 * @property {String} title - Title for the plugin icon.
		 */
		title: "CanvasShapeAlignLeft",

		/**
		 * @property {String} shapeAlignOption - Shape align option: Top.
		 */
		shapeAlignOption: "left"
	});
});
